import React from 'react';
import styled, { css } from 'styled-components';
import { noop } from 'lodash-es';
const Option = styled.div `
  padding: 0.75rem;
  ${props => css `
    color: ${({ theme }) => theme.colors[props.optionColor]};
  `}
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;

  > div {
    display: inline-flex;
    padding-right: 0.4375rem;
  }

  > span {
    display: inline-flex;
  }

  ${props => props.disabled === true &&
    css `
      color: ${({ theme }) => theme.colors.INK_400};
      cursor: not-allowed;
    `};

  ${props => {
    return css `
      &:hover {
        background-color: ${({ theme }) => theme.colors.PRIMARY_100};
        color: ${({ theme }) => theme.colors[props.optionColor]};
      }
    `;
}};

  &:active {
    background-color: ${({ theme }) => theme.colors.PRIMARY_200};
    color: ${({ theme, optionColor }) => theme.colors[optionColor]};
  }

  ${props => props.selected === true &&
    css `
      background-color: ${({ theme }) => theme.colors.PRIMARY_200};
      color: ${({ theme }) => theme.colors[props.optionColor]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.PRIMARY_200};
        color: ${({ theme }) => theme.colors.INK_700};
      }
    `};

  &:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  &:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;
const DropdownOption = ({ label, disabled = false, color, iconColor, Icon, iconDirection = 'TOP', selected, onClick, e2eId, customLabel, }) => {
    const optionLabel = customLabel || (React.createElement(React.Fragment, null,
        Icon && (React.createElement("div", null,
            React.createElement(Icon, { size: "MEDIUM", position: iconDirection, color: iconColor || color || 'INK_800' }))),
        React.createElement("span", null, label)));
    return (React.createElement(Option, { "data-e2e-id": e2eId, selected: selected, disabled: disabled, onClick: disabled || !onClick ? noop : onClick, optionColor: color || 'INK_800' }, optionLabel));
};
export default DropdownOption;
//# sourceMappingURL=DropdownOption.js.map